<template>
  <section class="community-section" :class="{ 'is-active': isActive }">
    <!-- 인트로 타이틀 -->
    <div class="intro-title" :class="{ hide: introDone }">
      <span>COMMUNITY</span>
    </div>

    <!-- 워터마크 텍스트 -->
    <div class="watermark-track" :class="{ show: introDone, running: introDone }">
      <span class="watermark-text">COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;</span>
      <span class="watermark-text">COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;COMMUNITY&nbsp;&nbsp;&nbsp;</span>
    </div>

    <!-- 데스크톱: 카드 3개 (A/B 플립) -->
    <div class="cards-row desktop-cards" :class="{ show: introDone }">
      <div
        v-for="(pair, idx) in cardPairs"
        :key="idx"
        class="card"
        :class="idx % 2 === 1 ? 'offset-down' : ''"
        :style="{ '--cd': (1.0 + idx * 0.4) + 's', '--flip-delay': (idx * 0.25) + 's' }"
      >
        <div class="card-img">
          <!-- A면 -->
          <img
            :src="pair.a.image"
            :alt="pair.a.title"
            class="card-face face-a"
            :class="{ out: flipped[idx] }"
          />
          <!-- B면 -->
          <img
            :src="pair.b.image"
            :alt="pair.b.title"
            class="card-face face-b"
            :class="{ in: flipped[idx] }"
          />
        </div>
        <div class="card-info">
          <transition name="text-swap" mode="out-in">
            <div :key="flipped[idx] ? 'b' : 'a'">
              <h4 class="card-title">{{ flipped[idx] ? pair.b.title : pair.a.title }}</h4>
              <p class="card-desc">{{ flipped[idx] ? pair.b.desc : pair.a.desc }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- 모바일: 6개 카드 한번에 -->
    <div class="cards-mobile">
      <div v-for="(zone, idx) in allZones" :key="idx" class="mobile-card">
        <div class="mobile-card-img">
          <img :src="zone.image" :alt="zone.title" />
        </div>
        <div class="mobile-card-body">
          <h4 class="mobile-card-title">{{ zone.title }}</h4>
          <p class="mobile-card-desc">{{ zone.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// 임시 mock 이미지 (Unsplash 고해상도 CDN)
const img1 = 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1000&q=80' // Healing (sauna)
const img2 = 'https://images.unsplash.com/photo-1567016432779-094069958ea5?w=1000&q=80' // Multiple (lounge)
const img3 = 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1000&q=80' // Member (private lounge)
const img4 = 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=1000&q=80' // Care (kids)
const img5 = 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1000&q=80' // Moms & Kids (cafe)
const img6 = 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1000&q=80' // Study (library)

export default {
  name: 'CommunitySection',
  props: {
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      introDone: false,
      introTimer: null,
      step: 0,
      flipped: [false, false, false],
      flipTimers: [],
      cardPairs: [
        {
          a: { image: img1, title: 'Healing Zone', desc: '외부 스파나 사우나 없이도 집 바로 아래에서 완성되는 나만의 힐링 루틴 (남녀 사우나, 샤워, 라커룸)' },
          b: { image: img4, title: 'Care Zone', desc: '아이부터 부모님까지 가족 모두를 위한 단지 내 케어 시스템 (어린이집, 노인정)' }
        },
        {
          a: { image: img2, title: 'Multiple Zone', desc: '소통과 여유가 공존하는 커뮤니티 라운지 (게스트룸, 스터디룸, 연회실)' },
          b: { image: img5, title: 'Moms & Kids Zone', desc: '육아와 소통을 동시에 지원하는 맞춤형 공간 (맘스카페, 맘스스테이션)' }
        },
        {
          a: { image: img3, title: 'Member Zone', desc: '일상의 피로를 회복하는 프라이빗 웰니스 공간 (게스트룸, 스터디룸, 연회실)' },
          b: { image: img6, title: 'Study Zone', desc: '소통과 여유가 공존하는 스터디 공간에서 집중과 성장을 동시에' }
        }
      ],
      allZones: [
        { image: img1, title: 'Healing Zone', desc: '외부 스파나 사우나 없이도 집 바로 아래에서 완성되는 나만의 힐링 루틴 (남녀 사우나, 샤워, 라커룸)' },
        { image: img2, title: 'Multiple Zone', desc: '소통과 여유가 공존하는 커뮤니티 라운지 (게스트룸, 스터디룸, 연회실)' },
        { image: img3, title: 'Member Zone', desc: '일상의 피로를 회복하는 프라이빗 웰니스 공간 (게스트룸, 스터디룸, 연회실)' },
        { image: img4, title: 'Care Zone', desc: '아이부터 부모님까지 가족 모두를 위한 단지 내 케어 시스템 (어린이집, 노인정)' },
        { image: img5, title: 'Moms & Kids Zone', desc: '육아와 소통을 동시에 지원하는 맞춤형 공간 (맘스카페, 맘스스테이션)' },
        { image: img6, title: 'Study Zone', desc: '소통과 여유가 공존하는 스터디 공간에서 집중과 성장을 동시에' }
      ]
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.introDone = false
        this.step = 0
        this.flipped = [false, false, false]
        this.clearFlipTimers()
        clearTimeout(this.introTimer)
        this.introTimer = setTimeout(() => {
          this.introDone = true
        }, 2000)
      } else {
        this.introDone = false
        this.step = 0
        this.flipped = [false, false, false]
        this.clearFlipTimers()
        clearTimeout(this.introTimer)
      }
    }
  },
  beforeUnmount() {
    clearTimeout(this.introTimer)
    this.clearFlipTimers()
  },
  methods: {
    clearFlipTimers() {
      this.flipTimers.forEach(t => clearTimeout(t))
      this.flipTimers = []
    },
    canScrollDown() {
      return this.introDone && this.step < 1
    },
    canScrollUp() {
      return this.step > 0
    },
    scrollDown() {
      if (this.step < 1) {
        this.step++
        this.clearFlipTimers()
        for (let i = 0; i < 3; i++) {
          const t = setTimeout(() => {
            this.flipped[i] = true
            this.flipped = [...this.flipped]
          }, i * 300)
          this.flipTimers.push(t)
        }
        return true
      }
      return false
    },
    scrollUp() {
      if (this.step > 0) {
        this.step--
        this.clearFlipTimers()
        for (let i = 2; i >= 0; i--) {
          const t = setTimeout(() => {
            this.flipped[i] = false
            this.flipped = [...this.flipped]
          }, (2 - i) * 300)
          this.flipTimers.push(t)
        }
        return true
      }
      return false
    },
    resetStep() {
      this.step = 0
      this.flipped = [false, false, false]
      this.clearFlipTimers()
    }
  }
}
</script>

<style scoped>
.community-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== 인트로 타이틀 ===== */
.intro-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  z-index: 10;
  transition: opacity 1.2s ease, transform 1.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.intro-title span {
  font-family: var(--font-pretendard);
  font-size: clamp(36px, 4vw, 56px);
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: 8px;
  text-transform: uppercase;
}

.intro-title.hide {
  opacity: 0;
  transform: translate(-50%, -50%) scale(3.5);
}

/* ===== 워터마크 ===== */
.watermark-track {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  white-space: nowrap;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  transition: opacity 2.5s ease;
}

.watermark-track.show {
  opacity: 1;
}

.watermark-track.running {
  animation: marquee 60s linear infinite;
}

.watermark-text {
  font-family: var(--font-pretendard);
  font-size: clamp(120px, 15vw, 220px);
  font-weight: 900;
  color: rgba(0, 0, 0, 0.04);
  letter-spacing: 8px;
  text-transform: uppercase;
  flex-shrink: 0;
}

@keyframes marquee {
  0% { transform: translateY(-50%) translateX(0); }
  100% { transform: translateY(-50%) translateX(-50%); }
}

/* ===== 카드 공통 ===== */
.cards-row {
  position: absolute;
  z-index: 2;
  display: flex;
  gap: 24px;
  padding: 0 80px;
  width: 100%;
  align-items: flex-start;
  top: 50%;
  transform: translateY(-50%);
}

.card {
  flex: 1;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1.4s cubic-bezier(0.16, 1, 0.3, 1),
              transform 1.4s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: var(--cd);
}

.cards-row.show .card {
  opacity: 1;
  transform: translateY(0);
}

/* ===== 이미지 크로스페이드 ===== */
.card-face {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.8s ease, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.face-a {
  opacity: 1;
  transform: scale(1);
}

.face-a.out {
  opacity: 0;
  transform: scale(1.05);
}

.face-b {
  opacity: 0;
  transform: scale(0.95);
}

.face-b.in {
  opacity: 1;
  transform: scale(1);
}

/* ===== 텍스트 전환 ===== */
.text-swap-enter-active {
  transition: opacity 0.5s ease, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.text-swap-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.text-swap-enter-from {
  opacity: 0;
  transform: translateY(12px);
}

.text-swap-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.card.offset-down {
  margin-top: 60px;
}

.card-img {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  margin-bottom: 16px;
}

.card-info {
  padding: 0 4px;
}

.card-title {
  font-family: var(--font-pretendard);
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.card-desc {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.4);
  margin: 0;
  line-height: 1.6;
}

/* ===== 모바일 전용 6카드 (2x3 그리드) ===== */
.cards-mobile {
  display: none;
  padding: 0 16px 40px;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mobile-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.mobile-card-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.mobile-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.mobile-card-body {
  padding: 12px 14px 16px;
}

.mobile-card-title {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.mobile-card-desc {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 400;
  color: #666;
  line-height: 1.5;
  margin: 0;
  word-break: keep-all;
}

/* ===== 반응형 ===== */
@media (max-width: 1200px) {
  .cards-row { padding: 0 48px; gap: 16px; }
  .card-title { font-size: 16px; }
  .card.offset-down { margin-top: 40px; }
}

/* --- 태블릿 (1024px) --- */
@media (max-width: 1024px) {
  .cards-row {
    padding: 0 36px;
    gap: 14px;
  }

  .card-title {
    font-size: 15px;
  }

  .card-desc {
    font-size: 13px;
  }

  .card.offset-down {
    margin-top: 36px;
  }

  .intro-title span {
    font-size: clamp(30px, 5vw, 48px);
    letter-spacing: 6px;
  }

  .watermark-text {
    font-size: clamp(80px, 12vw, 160px);
  }
}

@media (max-width: 900px) {
  .cards-row { padding: 0 24px; gap: 12px; }
  .card-img { aspect-ratio: 2 / 3; }
  .card-title { font-size: 14px; }
  .card-desc { font-size: 11px; }
  .card.offset-down { margin-top: 30px; }
  .intro-title span { font-size: clamp(28px, 8vw, 48px); letter-spacing: 4px; }
}

/* --- 모바일 (768px) --- */
@media (max-width: 768px) {
  .community-section {
    display: block !important;
    padding: 80px 0 40px !important;
    height: auto !important;
    min-height: auto !important;
    overflow: visible !important;
  }

  /* 데스크톱 카드 + 워터마크 + 인트로 타이틀 숨김 */
  .desktop-cards,
  .cards-row.desktop-cards { display: none !important; }
  .intro-title { display: none !important; }
  .watermark-track { display: none !important; }

  /* 모바일 카드 노출 (2x3 그리드) */
  .cards-mobile {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px !important;
    padding: 0 16px !important;
    width: 100%;
    box-sizing: border-box;
    position: static;
  }

  .mobile-card {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
    position: static;
  }

  /* 인트로 타이틀 모바일 */
  .intro-title span {
    font-size: clamp(24px, 7vw, 36px);
    letter-spacing: 3px;
  }

  .intro-title.hide {
    transform: translate(-50%, -50%) scale(2.5);
  }

  /* 워터마크 모바일 */
  .watermark-text {
    font-size: clamp(60px, 18vw, 100px);
    letter-spacing: 4px;
  }

  /* 카드 레이아웃: 2x2 그리드 */
  .cards-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding: 0 20px;
    top: 50%;
    transform: translateY(-50%);
    align-items: start;
  }

  .card {
    flex: none;
    width: 100%;
  }

  /* 오프셋 제거 — 2x2에서는 불필요 */
  .card.offset-down {
    margin-top: 0;
  }

  .card-img {
    aspect-ratio: 4 / 5;
    margin-bottom: 10px;
    border-radius: 6px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 4px;
  }

  .card-desc {
    font-size: 13px;
    line-height: 1.5;
    color: #555;
  }

  .card-info {
    padding: 0 2px;
    min-height: 52px;
  }
}

/* --- 소형 모바일 (480px) --- */
@media (max-width: 480px) {
  .intro-title span {
    font-size: clamp(20px, 7vw, 28px);
    letter-spacing: 2px;
  }

  .watermark-text {
    font-size: clamp(48px, 16vw, 72px);
    letter-spacing: 2px;
  }

  .cards-row {
    gap: 12px;
    padding: 0 16px;
  }

  .card-img {
    aspect-ratio: 3 / 4;
    margin-bottom: 8px;
  }

  .card-title {
    font-size: 15px;
  }

  .card-desc {
    font-size: 12px;
    line-height: 1.45;
  }

  .card-info {
    min-height: 46px;
  }
}
</style>
